import React from "react";

const LoanListings = () => {
  return <div>LoanListings</div>;
};

export default LoanListings;
